import { render, staticRenderFns } from "./addAudit.vue?vue&type=template&id=6a70ac17&scoped=true"
import script from "./addAudit.vue?vue&type=script&lang=js"
export * from "./addAudit.vue?vue&type=script&lang=js"
import style0 from "./addAudit.vue?vue&type=style&index=0&id=6a70ac17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70ac17",
  null
  
)

export default component.exports